import { useState, useCallback } from 'react';
import { dashboardApi } from '../API/dashboard';

export const useDashboard = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Dashboard summary (no period required)
  const getDashboardData = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const result = await dashboardApi.getDashboardData();

      if (result?.error) {
        setError(result.error);
        return null;
      }

      return result;
    } catch (err) {
      console.error('Dashboard fetch failed:', err);
      setError('Failed to fetch dashboard data');
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  // Chart data (requires period or custom range)
  const getDashboardChartAndCardData = useCallback(async (selectedPeriod, customRange = null) => {
    setLoading(true);
    setError(null);

    try {
      const payload = {};

      switch (selectedPeriod) {
        case '7 days':
          payload.period = '7d';
          break;
        case '30 days':
          payload.period = '30d';
          break;
        case '12 months':
          payload.period = '12m';
          break;
        case 'Custom':
          if (customRange?.start && customRange?.end) {
            payload.period = 'custom';
            payload.startDate = customRange.start;
            payload.endDate = customRange.end;
          } else {
            setError('Custom range requires start and end dates');
            return null;
          }
          break;
        default:
          payload.period = '7d';
      }

      const result = await dashboardApi.getDashboardChartAndCardData(payload);

      if (result?.error) {
        setError(result.error);
        return null;
      }

      return result;
    } catch (err) {
      console.error('Chart data fetch failed:', err);
      setError('Failed to fetch chart data');
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    loading,
    error,
    getDashboardData,
    getDashboardChartAndCardData,
  };
};
